import { render, staticRenderFns } from "./BetaMessage.vue?vue&type=template&id=64ce3a36&"
import script from "./BetaMessage.vue?vue&type=script&lang=js&"
export * from "./BetaMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports